// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import useTranslation from "next-translate/useTranslation";
import PropTypes from "prop-types";

import { Dialog, Grid, Typography, Button } from "@/components/core";

export function MessageDialog({ open, onClose, message, sx, title }: any) {
  const { t } = useTranslation("common");

  return (
    <Dialog open={open} onClose={onClose} defaultTitle title={title} sx={sx}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "center", textAlign: "center", py: 1 }}
        >
          <Typography sx={{ wordWrap: "break-word", width: "100%" }}>{message}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "center", textAlign: "center", py: 1 }}
        >
          <Button onClick={onClose} variant="contained">
            {t("bank:close")}
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
}

MessageDialog.propTypes = {
  open: PropTypes.any,
  onClose: PropTypes.func,
  message: PropTypes.string,
  sx: PropTypes.any,
  title: PropTypes.string,
};
